<!--
  --
  -- 免許証の種類
  --
  -->
<template>
  <v-item-group
    class="c-license-type-select-group"
    :class="{'is-mobile': $vuetify.breakpoint.xsOnly}"
    multiple
    :value="value"
    @change="$emit('change', $event)"
  >
    <v-item
      v-for="item in items"
      :key="item.value"
      :value="item.value"
      v-slot="{ active, toggle }"
    >
      <div class="c-license-type-select-group-item">
        <v-sheet
          :class="active ? actived : inactived"
          v-text="item.label"
          rounded
          v-ripple
          @click="toggle"
        />
      </div>
    </v-item>
  </v-item-group>
</template>

<style lang="scss">
.c-license-type-select-group {
  display: flex;
  flex-flow: row wrap;
  margin: -4px;

  .c-license-type-select-group-item {
    flex: 0 0 (100% / 7);
    padding: 4px;
    width: (100% / 7);
  }

  .v-sheet {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;

    font-size: 11px;
    line-height: 14px;
    letter-spacing: 0.0333333333em;

    cursor: pointer;
    user-select: none;

    height: 32px;
  }
}

.c-license-type-select-group.is-mobile {
  .v-sheet {
    height: 40px;
  }
}
</style>

<script>
export default {
  name: 'CItemGroup',

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },

    items: {
      type: Array,
      required: true
    }
  },
  computed: {
    dark () {
      return this.isDarkColor('primary')
    },

    actived () {
      return ['primary', this.dark ? 'white--text' : '']
    },

    inactived () {
      return this.$vuetify.theme.isDark ? ['grey', 'darken-3'] : ['grey', 'lighten-3']
    }
  }
}
</script>
